import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import LoadingSpinner from "../components/LoadingSpinner";
import Step1 from "../pages/Step1";
import { verifyCardOnFile } from "../utils/apiHandler";

const Login = () => {
  const [isTokenChecked, setIsTokenChecked] = useState(false);

  const navigate = useNavigate();
  const {
    isAuthenticated,
    isLoading,
    user,
    getAccessTokenSilently,
    getIdTokenClaims,
  } = useAuth0();

  useEffect(() => {
    let isMounted = true;

    var paymentPlan = localStorage.getItem("plan_type")
    const authenticate = async () => {
      if (isAuthenticated) {
        try {
          await getAccessTokenSilently({ cacheMode: 'off', ignoreCache: true });
        } catch (error) {
          navigate('/authorize');
        }
        const idTokenClaims = await getIdTokenClaims();
        const idToken = idTokenClaims?.__raw;
        if (idToken && isMounted) {
          const decodedToken = jwtDecode(idToken);
          if (!decodedToken.plan_type && !paymentPlan) {
            // setting default plan
            paymentPlan = 'monthly'
          }

          if (
            decodedToken.accepted_terms &&
            decodedToken.mls_active &&
            decodedToken.broker_verified
          ) {
            // setIsTokenChecked(true);
            if(await verifyCardOnFile(idToken, paymentPlan))
              navigate("/chat");
          } else if (decodedToken?.accepted_terms && decodedToken.mls_active && !(decodedToken?.broker_mls_id)) {
            setIsTokenChecked(true);
            navigate("/step3");
          } else if (decodedToken?.accepted_terms) {
            setIsTokenChecked(true);
            navigate("/step1");
          } else {
            setIsTokenChecked(true);
          }
        }
      }
    };

    authenticate();

    return () => {
      isMounted = false;
    };
  }, [getIdTokenClaims, isAuthenticated, getAccessTokenSilently, navigate]);

  if (isLoading || !isTokenChecked) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated && !isLoading) {
  }
  return (
    <div>
      <Step1 />
    </div>
  );
};

export default Login;
